import { render } from "./IletsSlider2.vue?vue&type=template&id=10d1f85e&scoped=true"
import script from "./IletsSlider2.vue?vue&type=script&lang=js"
export * from "./IletsSlider2.vue?vue&type=script&lang=js"

import "./IletsSlider2.vue?vue&type=style&index=0&id=10d1f85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d1f85e"]])

export default __exports__